import { FC } from 'react';

import { useFormikContext } from 'formik';
import { Button } from 'ui/components/common';
import { Input } from 'ui/components/form';
import { SIZE } from 'utils/constants';
import { cn } from 'utils/helpers';
import { ADDRESS_FORM } from 'modules/account/contact/forms/schema';
import useModal from 'ui/partials/Modal/useModal';

interface PROPS {
  isCompany?: boolean;
}

const QuickEditAddressForm: FC<PROPS> = ({ isCompany }) => {
  const { hideModal } = useModal();

  const {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
  } = useFormikContext<ADDRESS_FORM>();

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex flex-col gap-y-4">
        {!isCompany && (
          <Input
            className="w-full"
            type="text"
            name="country"
            size={SIZE.Small}
            textType={errors.country && touched.country ? 'danger' : 'default'}
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.country}
            placeholder="Country"
            subText={
              errors.country && touched.country ? errors.country : undefined
            }
            label="Country"
            disabled={isSubmitting}
          />
        )}
        <Input
          className="w-full"
          type="text"
          name="state"
          size={SIZE.Small}
          textType={errors.state && touched.state ? 'danger' : 'default'}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.state}
          placeholder="State"
          subText={errors.state && touched.state ? errors.state : undefined}
          label="State"
          disabled={isSubmitting}
        />
        <Input
          className="w-full"
          type="text"
          name="city"
          size={SIZE.Small}
          textType={errors.city && touched.city ? 'danger' : 'default'}
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.city}
          placeholder="City"
          subText={errors.city && touched.city ? errors.city : undefined}
          label="City"
          disabled={isSubmitting}
        />
        {!isCompany ? (
          <>
            <Input
              className="w-full"
              type="text"
              name="streetAddress1"
              size={SIZE.Small}
              textType={
                errors.streetAddress1 && touched.streetAddress1
                  ? 'danger'
                  : 'default'
              }
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.streetAddress1}
              subText={
                errors.streetAddress1 && touched.streetAddress1
                  ? errors.streetAddress1
                  : undefined
              }
              label="Street Address 1"
              disabled={isSubmitting}
            />
            <Input
              className="w-full"
              type="text"
              name="streetAddress2"
              size={SIZE.Small}
              textType={
                errors.streetAddress2 && touched.streetAddress2
                  ? 'danger'
                  : 'default'
              }
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.streetAddress2}
              subText={
                errors.streetAddress2 && touched.streetAddress2
                  ? errors.streetAddress2
                  : undefined
              }
              label="Street Address 2"
              disabled={isSubmitting}
            />
            <Input
              className="w-full"
              type="text"
              name="zipcode"
              size={SIZE.Small}
              textType={
                errors.zipcode && touched.zipcode ? 'danger' : 'default'
              }
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.zipcode}
              subText={
                errors.zipcode && touched.zipcode ? errors.zipcode : undefined
              }
              label="Zip Code"
              disabled={isSubmitting}
            />
          </>
        ) : (
          <Input
            className="w-full"
            type="text"
            name="postalCode"
            size={SIZE.Small}
            textType={
              errors.postalCode && touched.postalCode ? 'danger' : 'default'
            }
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.postalCode}
            subText={
              errors.postalCode && touched.postalCode
                ? errors.postalCode
                : undefined
            }
            label="Postal Code"
            disabled={isSubmitting}
          />
        )}
      </div>
      <div
        className={cn(
          'mt-5 pt-5',
          'flex gap-3 justify-end',
          'border-t-[0.5px] border-separator-primary',
        )}
      >
        <Button
          onClick={hideModal}
          type="button"
          disabled={isSubmitting}
          label="CANCEL"
          intent="tertiary"
          size="sm"
        />
        <Button disabled={isSubmitting} label="SAVE" type="submit" size="sm" />
      </div>
    </form>
  );
};

export default QuickEditAddressForm;
